import React from 'react';
import { Typography, colors } from 'kangarootime-ui';
import classnames from 'classnames';
import { ClipLoader } from 'react-spinners';
import './Toolbar.css';

let CURRENT_MONTH;

const Toolbar = ({ toolbar, onMonthChange, fetchingEvents }) => {
  const { onNavigate, onView, view: currentView, date } = toolbar;

  // set initial value
  if (CURRENT_MONTH === undefined) {
    CURRENT_MONTH = date.getMonth();
  }

  // fetch events when the month changes in any view
  if (date.getMonth() !== CURRENT_MONTH) {
    onMonthChange(date);
    CURRENT_MONTH = date.getMonth();
  }

  const activeViewStyling = view => classnames({
    'rbc-override-btn': true,
    'rbc-override-btn-active': view === currentView
  });

  return (
    <div className='rbc-toolbar'>
      <span className='rbc-btn-group'>
        <button className='rbc-override-btn' type='button' onClick={() => onNavigate('TODAY')}>
          <Typography style={{ color: colors.brand_1, fontWeight: 600 }}>Today</Typography>
        </button>
        <button className='rbc-override-btn' type='button' onClick={() => onNavigate('PREV')}>
          <Typography>Back</Typography>
        </button>
        <button className='rbc-override-btn' type='button' onClick={() => onNavigate('NEXT')}>
          <Typography>Next</Typography>
        </button>
      </span>
      <div className='flex-rows' style={{ flexGrow: 1, alignItems: 'center', justifyContent: 'center' }}>
        <Typography type='header' style={{ textAlign: 'center', marginLeft: 4 }}>{toolbar.label}</Typography>
        <div style={{ marginLeft: 4, width: 14 }}>
          <ClipLoader loading={fetchingEvents} size={14} color='#FF7CC3' />
        </div>
      </div>
      <span className='rbc-btn-group'>
        <button className={activeViewStyling('month')} type='button' onClick={() => onView('month')}>
          <Typography style={{ color: currentView === 'month' && '#FFFFFF' }}>Month</Typography>
        </button>
        <button className={activeViewStyling('week')} type='button' onClick={() => onView('week')}>
          <Typography style={{ color: currentView === 'week' && '#FFFFFF' }}>Week</Typography>
        </button>
        <button className={activeViewStyling('day')} type='button' onClick={() => onView('day')}>
          <Typography style={{ color: currentView === 'day' && '#FFFFFF' }}>Day</Typography>
        </button>
      </span>
    </div>
  );
};

export default Toolbar;
